import React from "react";
import LoginWaitImg from "../../assets/svgicons/login-wait-icon.svg";

const LoginWaitIcon = () => {
	return <img src={LoginWaitImg} alt="Wait" />;
};

export default LoginWaitIcon;
